import React, { useCallback, useState } from 'react';
import { mapModifiers, ModifierProp } from 'libs/component';
import { OptionItem } from 'components/atoms/option-item';
import { useEffect } from 'react';

export interface OptionListProps {
  currentIndex?: number;
  items: string[];
  modifiers?: ModifierProp<'horizontal'>;
  onSelected?: (index: number) => void;
}

export const OptionList: React.FC<OptionListProps> = ({ currentIndex = 0, items, modifiers, onSelected }) => {
  const [selectedIndex, setSelectedIndex] = useState(currentIndex);

  useEffect(() => {
    setSelectedIndex(currentIndex);
  }, [currentIndex]);

  const handleItemSelected = useCallback(
    (index: number) => {
      setSelectedIndex(index);
      if (onSelected) {
        onSelected(index);
      }
    },
    [onSelected]
  );
  return (
    <div className={mapModifiers('m-option-list', modifiers)}>
      {items.map((item, index) => (
        <OptionItem
          key={index}
          modifiers={selectedIndex === index ? 'active' : undefined}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick={() => handleItemSelected(index) as any}
        >
          {item}
        </OptionItem>
      ))}
    </div>
  );
};
